<app-modal
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onShowing)="onShowingInternal()"
  (onHidden)="onHiddenInternal()"
  [closeOutsideClickEnabled]="false"
  modalTitle="Histórico"
  width="25rem"
  height="43.5rem"
>
  <ng-template modalContent>
    <div class="content">
      <div class="list">
        <app-radio-group
          class="radio-group"
          [items]="items"
          [(value)]="itemIdSelected"
          (onItemSelected)="onItemSelected($event)"
          displayExpr="name"
          valueExpr="id"
          [showIcon]="false"
        >
          <ng-template radioGroupItem let-item="item" let-label="label">
            <div class="item">
              <div class="label">
                {{ label }}
              </div>

              <app-button
                class="btn-remove"
                buttonType="danger"
                styleType="text"
                sizeType="normal"
                shapeType="circle"
                icon="assets/icons/trash.svg"
                (click)="onBtnDeleteClick($event, item)"
              ></app-button>
            </div>
          </ng-template>
        </app-radio-group>
      </div>

      <div class="actions-bottom">
        <app-button
          buttonType="primary"
          styleType="contained"
          text="Aplicar"
          (click)="onBtnApplyClick()"
          [disabled]="!itemSelected"
          width="100%"
        ></app-button>

        <app-button
          buttonType="normal"
          styleType="contained"
          text="Cancelar"
          (click)="onBtnCancelClick()"
          width="100%"
        ></app-button>
      </div>
    </div>
  </ng-template>
</app-modal>
